import type { IUploadRepository } from '../repositories/IUploadRepository.js';
import type { MediaFolderArgs } from '../../data/datasources/SupabaseUploadRemoteDataSource.js';

interface Deps { uploadRepository: IUploadRepository; }

/** Resolve the canonical media folder server-side (single source of truth). */
export function createGetMediaFolderUseCase({ uploadRepository }: Deps) {
  return function getMediaFolder(args: MediaFolderArgs): Promise<string | null> {
    return uploadRepository.getMediaFolder(args);
  };
}
